// Loaded by snippets/sham-edit-cart-guard.liquid. Not a custom element: it has
// to act before the page renders, on every page, with no markup of its own.
(function () {
  var MARK = '_tmc_edit_txn';
  var PENDING_KEY = 'shamEditCartDiscarded';
  var SKIP_KEY = 'shamEditCartGuardSkip';
  var GIVE_UP_AFTER_MS = 4000;

  var script = document.currentScript;
  var cartUrl = script.dataset.cartUrl || '/cart';
  var root = document.documentElement;
  var here = location.pathname + location.search;

  // Same test as is_edit_mode in snippets/initial-storage.liquid, which sets
  // subscriptionEditModeEnabled later in the head.
  function inEditMode() {
    if (window.subscriptionEditModeEnabled === true) return true;
    var query = location.search;
    return query.indexOf('transactionId') !== -1 && query.indexOf('token') !== -1;
  }

  function session(action, key, value) {
    try {
      if (action === 'get') return sessionStorage.getItem(key);
      if (action === 'set') sessionStorage.setItem(key, value);
      if (action === 'remove') sessionStorage.removeItem(key);
    } catch (error) {}
    return null;
  }

  function request(path, options, signal) {
    return fetch(cartUrl + path, Object.assign({ signal: signal }, options)).then(function (response) {
      if (!response.ok) throw new Error(path + ' answered ' + response.status);
      return response.json();
    });
  }

  // One cart/update.js both zeroes the lines and drops the mark, so a failure
  // can never leave an emptied cart that is still marked.
  function emptyAndUnmark(signal) {
    return request('.js', {}, signal).then(function (cart) {
      var updates = {};
      cart.items.forEach(function (item) { updates[item.key] = 0; });
      var attributes = {};
      attributes[MARK] = '';
      return request('/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates, attributes: attributes }),
      }, signal).then(function (after) {
        if (after.item_count !== 0 || (after.attributes && after.attributes[MARK])) {
          throw new Error('cart still holds the edit-mode box');
        }
        return cart.items.length;
      });
    });
  }

  // location.replace, not reload: reload would resend a form POST, and a URL
  // with only a #fragment changed would scroll instead of loading.
  function reloadPage() {
    location.replace(here);
  }

  function discard(options) {
    root.hidden = true;
    if (options.stopPage) window.stop();
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, GIVE_UP_AFTER_MS);
    emptyAndUnmark(controller && controller.signal)
      .then(function (lines) {
        clearTimeout(timer);
        if (lines > 0) session('set', PENDING_KEY, String(lines));
        reloadPage();
      })
      .catch(function (error) {
        // The cart stays marked, so the next page load tries again.
        clearTimeout(timer);
        console.warn('Edit-mode cart not discarded:', error.message);
        if (options.stopPage) {
          session('set', SKIP_KEY, here);
          reloadPage();
        } else {
          root.hidden = false;
        }
      });
  }

  var pending = session('get', PENDING_KEY);
  session('remove', PENDING_KEY);
  if (pending !== null) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'edit_mode_cart_discarded', lines: Number(pending) });
  }

  var skipThisLoad = session('get', SKIP_KEY) === here;
  session('remove', SKIP_KEY);

  if ('markedLines' in script.dataset && !inEditMode() && !skipThisLoad) {
    if (Number(script.dataset.markedLines) > 0) {
      discard({ stopPage: true });
    } else {
      emptyAndUnmark(null).catch(function () {});
    }
  }

  function markedCart() {
    return request('.js', {}, null).then(function (cart) {
      return cart.attributes && cart.attributes[MARK] ? cart : null;
    });
  }

  // For checkout code that never reloads the page (cart drawer, /cart).
  window.shamEditCartGuard = {
    discard: function () { discard({ stopPage: false }); },
  };

  // An edit tab may hold a box that another tab has since discarded, so on
  // being shown again it rebuilds from Loop. Pages restored by Back need no
  // handler here: bundle-page.js reloads every page restored from the
  // back/forward cache, and the reload runs this guard.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible' || !inEditMode() || document.readyState !== 'complete') return;
    markedCart()
      .then(function (cart) { if (!cart) location.reload(); })
      .catch(function () {});
  });
})();
